import {t} from 'i18next';
import React from 'react';
import {components, ValueContainerProps} from 'react-select';
import {Icon} from '@iconify/react';
import {IOptions, MultiQuestionSelectProps} from './MultiselectQuestionElement';

function MultiSelectValueContainer(props: ValueContainerProps<IOptions, true>): JSX.Element {
    const {getValue, children, selectProps} = props;

    const answered =
        'selectProps' in selectProps &&
        'answered' in (selectProps.selectProps as MultiQuestionSelectProps) &&
        (selectProps.selectProps as MultiQuestionSelectProps).answered;

    const singleCorrect =
        'selectProps' in selectProps &&
        'singleCorrect' in (selectProps.selectProps as MultiQuestionSelectProps) &&
        (selectProps.selectProps as MultiQuestionSelectProps).singleCorrect;

    const correctAnswered = getValue().filter((item) => item.type === 'correct').length;
    const incorrectAnswered = getValue().filter((item) => item.type === 'incorrect').length;
    const debatableAnswered = getValue().filter((item) => item.type === 'debatable').length;

    function getValueText(): JSX.Element | null {
        const {length} = getValue();
        if (!length) return null;

        if (singleCorrect) {
            return <div className="c-multiSelectElement__valueSelected">{getValue()[0].label}</div>;
        }

        if (!answered) {
            return (
                <div className="c-multiSelectElement__valueSelected">
                    {length} {t('slide.elements.multiselectQuestion.noOfSelected')}
                </div>
            );
        }

        return (
            <div>
                {[
                    {
                        count: correctAnswered,
                        icon: 'solar:check-square-linear',
                        className: 'c-multiSelectElement__valueAnswered_correct',
                    },
                    {
                        count: incorrectAnswered,
                        icon: 'solar:close-square-linear',
                        className: 'c-multiSelectElement__valueAnswered_incorrect',
                    },
                    {
                        count: debatableAnswered,
                        icon: 'solar:question-square-linear',
                        className: 'c-multiSelectElement__valueAnswered_debatable',
                    },
                ]
                    .filter(({count}) => count > 0)
                    .map(({count, icon, className}) => (
                        <span key={icon} className={`c-multiSelectElement__valueAnswered ${className}`}>
                            {count} <Icon icon={icon} />
                        </span>
                    ))}
            </div>
        );
    }

    return (
        <components.ValueContainer {...props}>
            {getValueText()}
            <div style={{display: 'contents', opacity: 0, height: 0, overflow: 'hidden'}}>{children}</div>
        </components.ValueContainer>
    );
}

export default MultiSelectValueContainer;
